import { concatStyleSets, IconButton } from '@fluentui/react';
import React from 'react';
import { useMemo } from 'react';

const EUIIconButton = (props) => {

    // PROPS
    const {
        styles = {}
    } = props;

    // MEMOS
    const _styles = useMemo(() => {
        return concatStyleSets(
            { root: { color: "rgb(39, 39, 39)" } },
            styles
        );
    }, [styles])

    // RENDER
    return <IconButton {...props} styles={_styles} />;

};

export default EUIIconButton;